import React, { useContext, useEffect, useState } from "react";
import UINotification from "../components/Misc/UINotification";
import { useIsMounted } from "../hooks/useIsMounted";
import { isArrayTruthy } from "../utils";
const NotificationContext = React.createContext();

export function useNotification() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
  const inactiveNotification = {
    message: null,
    iconName: null,
    hex: null,
    action: null,
  };
  const [notification, setNotification] = useState(inactiveNotification);

  let isMounted = useIsMounted();

  useEffect(() => {
    if (isArrayTruthy(Object.values(notification))) {
      setTimeout(() => {
        if (isMounted.current) setNotification(inactiveNotification);
      }, 7100);
    }
  }, [notification]); // eslint-disable-line react-hooks/exhaustive-deps

  const value = {
    setNotification,
  };

  return (
    <NotificationContext.Provider value={value}>
      {isArrayTruthy(Object.values(notification)) && (
        <UINotification
          message={notification.message}
          iconName={notification.iconName}
          hex={notification.hex}
          action={notification?.action}
          onClose={notification?.onClose}
        />
      )}
      {children}
    </NotificationContext.Provider>
  );
}
